
import { formatSummary } from "./utils/ProfileUtils";

interface CandidateSummaryProps {
  summary?: string;
}

export const CandidateSummary = ({ summary }: CandidateSummaryProps) => {
  const formattedSummary = formatSummary(summary);
  
  if (!formattedSummary) return null;
  
  return (
    <div>
      <p className="text-sm text-muted-foreground whitespace-pre-line leading-relaxed">
        {formattedSummary}
      </p>
    </div>
  );
};
